import React, { useEffect, useState } from 'react';
import { CarryOutOutlined } from '@ant-design/icons';
import { Tree } from 'antd';
import type { TreeDataNode } from 'antd';
import AddSection from './addSection';
import { Link } from 'react-router';
import { Section, Unit } from '../../../../types/dataModel';
import EditSection from './editSection';
import DeleteSection from './deleteSection';

const ROOT_ELE = "Syllabus Content"


interface Props {
  heading?: string
  data: any[] 
  onSave: (data:any)=> void
  onStateUpdate: (data:any)=> void
  readonly?: boolean
  onNodeClick?: (node: any) => void
  onAddNode?: (node: any) => void
  onDeleteNode?: (node: any) => void
  onEditNode?: (node: any) => void
}

const SectionTreeView = ({data, onSave, readonly, onNodeClick, onStateUpdate, onAddNode, onDeleteNode, onEditNode, heading = ROOT_ELE}:Props) => {

  const [liveTreeData, setLiveTreeData] = useState<TreeDataNode[]>([])
  const [activeRecord, setActiveRecord] = useState<any>({key:"", value:""});
  const [expandedKeys, setExpandedKeys] = useState<any[]>([]);

  const expandAll = () => {
    const allKeys = liveTreeData?.flatMap(getAllKeys);
    setExpandedKeys(allKeys);
  };

  // Function to collapse all nodes
  const collapseAll = () => {
    setExpandedKeys([]);
  };

  // Function to extract all keys from onStateUpdatetreeData
  const getAllKeys = (node:any) => {
    let keys = [node.key];
    if (node.children) {
      keys = keys.concat(node.children.flatMap(getAllKeys));
    }
    return keys;
  };

  const onExpand = (newExpandedKeys:any[]) => {
    setExpandedKeys(newExpandedKeys);
  };

  useEffect(()=>{
    if(liveTreeData?.length && liveTreeData[0].children && onStateUpdate){
      let secs: any[] = []
      parseToSections(liveTreeData[0].children, secs)
      onStateUpdate(secs)
    }
  },[liveTreeData])

  useEffect(()=>{
    if(!data?.length){
      let node = { title: heading, key: `${0}`, nodeType: 'SYLLABUS',icon: <CarryOutOutlined />, children: [] }
      setLiveTreeData([node])
    } else {
      let node:any = { title: heading, key: `${0}`, nodeType: 'SYLLABUS', icon: <CarryOutOutlined />, children: parseUnitsToTreeData(data) }
      setLiveTreeData([node])
    }
  },[data])

  const renderTitle = (record: any) => (
    
    <div style={{flexDirection:'row'}}>
        

        {
          record?.nodeType === "SYLLABUS" 
          ?
          <>
            <i className='bg-secondary br-5 p-1 fs-16'>{record?.title}</i> 
            {
            readonly
            ?
              <></>:
              <>
              <Link
                to="#"
                data-bs-toggle="modal" data-inert={true}
                data-bs-target="#add_section"
                className="align-items-center m-0 p-0"
                onClick={()=>{
                  setActiveRecord({...record, key:record?.key, value:record?.title})
                }}
              >
                  <i className="ti ti-circle-plus ms-2 me-2" />
              </Link>
              <Link
                    to="#"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#study_material_modal"
                    className="align-items-center m-0 p-0"
                    onClick={(e) => {
                      e.preventDefault();
                      if (onNodeClick) {
                        onNodeClick(record);
                      }
                    }}
                  >
                    <i className="ti ti-book text-primary me-2" title="Study Materials" />
              </Link>
              </>
            }


          </>
          :
          <>
            <i className='bg-primary br-5 p-1 fs-12 d-inline-md-block'>{record?.title}</i> 
            {
              readonly
              ?
                <></>
              :
                <>
                  <Link
                    to="#"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#add_section"
                    className="align-items-center m-0 p-0"
                    onClick={() => {
                      setActiveRecord({ ...record, key: record?.key, value: record?.title })
                    }}
                  >
                    <i className="ti ti-circle-plus ms-2 me-2" />
                  </Link>
                  <Link
                    to="#"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#edit_section"
                    className="align-items-center m-0 p-0"
                    onClick={() => {
                      setActiveRecord({ ...record, key: record?.key, value: record?.title })
                    }}
                  >
                    <i className="ti ti-edit me-2" />
                  </Link>
                  <Link
                    to="#"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#delete_section"
                    className="align-items-center m-0 p-0"
                    onClick={() => {
                      setActiveRecord({ ...record, key: record?.key, value: record?.title })
                    }}
                  >
                    <i className="ti ti-trash me-2" />
                  </Link>
                  <Link
                    to="#"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#study_material_modal"
                    className="align-items-center m-0 p-0"
                    onClick={(e) => {
                      e.preventDefault();
                      if (onNodeClick) {
                        onNodeClick(record);
                      }
                    }}
                  >
                    <i className="ti ti-book text-primary me-2" title="Study Materials" />
                  </Link>
                </>
            }

          </>
        }

    </div>
  )
  
  
  const onSelect = (selectedKeys: React.Key[], info: any) => {
  };

  const renderAdd = () => {
    return (
      <AddSection onSuccess={(value:any)=>{
          let temp:TreeDataNode[] = [...liveTreeData]
          searchChildrenAndAdd(temp, activeRecord.key, value)
          setLiveTreeData(temp)
          if(temp?.length && temp[0]?.children){
            let secs: any[] = []
            parseToSections(temp[0]?.children, secs)
            // onStateUpdate(secs)
            // onSave(secs)
            onAddNode?.({
              title: value,
              parentId: activeRecord.id,
              parentNodeType: activeRecord.nodeType,
            })
          }
      }}/>
    )
  }

  const renderEdit = () => {
    return (
      <EditSection title={activeRecord.value} onSuccess={(value:any)=>{
          let temp = [...liveTreeData]
          searchChildrenAndEdit(temp, activeRecord.key, value)
          setLiveTreeData(temp)

          if(temp?.length && temp[0]?.children){
            let secs: any[] = []
            parseToSections(temp[0]?.children, secs)
            // onStateUpdate(secs)
            // onSave(secs)
            onEditNode?.({...activeRecord, title: value})
          }
      }}/>
    )
  }

  const renderDelete = () => {
    return (
      <DeleteSection title={activeRecord.value}
       onSuccess={()=>{
        let temp = [...liveTreeData]
        temp = searchChildrenAndRemoveAndReindex(temp, activeRecord.key)
        setLiveTreeData(temp)

        if(temp?.length && temp[0]?.children){
          let secs: any[] = []
          parseToSections(temp[0]?.children, secs)
          // onStateUpdate(secs)
          // onSave(secs)
          onDeleteNode?.(activeRecord)
        }
    }}/>
    )
  }

  return (
    <>
    <div className='gap-4'>
      <div className='mb-3 d-flex justify-content-between'>
        <div className='text-dark fs-18 text-center'>
           <h4 style={{textDecoration:'underline'}}>Index</h4>
        </div>
        <div>
        <button className='btn btn-xs btn-outline-dark me-2'
         onClick={expandAll}>
          <i className='ti ti-arrow-down' /> Expand All
        </button>
        <button className='btn btn-xs btn-outline-dark' onClick={collapseAll}>
          <i className='ti ti-arrow-up' /> Collapse All
        </button>
        </div>

      </div>
      <div className="d-flex">
      <Tree
          showLine={true}
          showIcon={false}
          onSelect={onSelect}
          treeData={liveTreeData}
          defaultExpandAll={liveTreeData?.length? true : false}
          titleRender={renderTitle}
          expandedKeys={expandedKeys}
          onExpand={onExpand}
        />
        
      </div>

    </div>

    {renderAdd()}
    {renderEdit()}
    {renderDelete()}
    </>
  );
};

const searchChildrenAndAdd = (root:TreeDataNode[] | undefined, parentKey:string, value: string) => {
  root?.forEach((ele:TreeDataNode,indx)=>{
        if(ele?.key === parentKey){
          let nextKey = getNextKey(ele?.key, ele?.children?.length )
          ele?.children?.push({ title: `${value}`, key: `${nextKey}`, icon: <CarryOutOutlined />, children:[] })
        } else {
          searchChildrenAndAdd(ele?.children, parentKey, value)
        }
  })
}

const searchChildrenAndEdit = (root:TreeDataNode[] | undefined, activeKey:string, value: string) => {
  root?.forEach((ele:TreeDataNode,indx)=>{
        if(ele?.key === activeKey){
          ele.title = value
        } else {
          searchChildrenAndEdit(ele?.children, activeKey, value)
        }
  })
}

const searchChildrenAndRemove = (root:TreeDataNode[] | undefined, activeKey:string) => {
  let rem = root?.findIndex((ele:TreeDataNode, idx) => {
        if(ele?.key === activeKey){
          return true;
        } else {
          searchChildrenAndRemove(ele?.children, activeKey)
        }
  })
  if (rem != null && rem !== -1) {
    root?.splice(rem, 1);
  }
}

const searchChildrenAndRemoveAndReindex = (root:TreeDataNode[], activeKey:string) => {
  let secs: any[] = []
  searchChildrenAndRemove(root,activeKey)
  parseToSections(root,secs)
  return parseUnitsToTreeData(secs)
}

const getNextKey = (parentKey: string, index: number|undefined) => {
   return `${parentKey}-${index}`
}

const parseToSections = (tree: any[], secs: any[]) => {
  tree?.forEach((item:any, idx)=>{
    let sec = { 
    name: `${item.title}`, 
    id: item.id, 
    sections: [], 
    nodeType: item.nodeType, 
    parentId: item.parentId
   }
     if(item?.children?.length){
      parseToSections(item?.children, sec.sections)
     }
     secs.push(sec)
  })
}

const parseUnitsToTreeData = ( units: Unit[]| undefined): TreeDataNode[] => {
  let nodes: TreeDataNode[] = []
  if(units?.length){
      units?.forEach((unit, indx)=>{
          let key = getNextKey('0', indx)
          let unitNode = parseToTreeNode(unit, key, 'UNIT', 'SYLLABUS', 0)
          if(unit?.sections?.length){
              parseSections(unitNode, unit.sections, key, 'UNIT', unit?.id)
          }

          nodes.push(unitNode)
      })

  }
  return nodes
}

const parseSections = (parentNode:any, sections: Section[], parentKey: string, parentType: string, parentId: number | undefined) => {
  let secnodes: TreeDataNode[] = []
  sections?.forEach((section, indx)=>{
      let nextKey = getNextKey(parentKey, indx)
      let secNode = parseToTreeNode(section, nextKey, 'SECTION', parentType, parentNode.id)
      
      if(section?.sections?.length){
          parseSections(secNode, section?.sections, nextKey, 'SECTION', section?.id)
      }
      secnodes.push(secNode)
  })
  parentNode.children = secnodes
}

const parseToTreeNode = (section: any, key: string, nodeType: string, parentNodeType: string, parentId: number | undefined):any => {    
  return { 
      title: `${section.name}`, 
      id: section.id, key: `${key}`, 
      icon: <CarryOutOutlined />, 
      children:[], 
      nodeType: nodeType,
      parentId: parentId,
      parentNodeType: parentNodeType
    }
}


export default SectionTreeView;